var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.text))]),(_vm.subtext)?_c('div',{staticClass:"title-subtext"},[_vm._v(_vm._s(_vm.subtext))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }